import { useState } from 'react';

export default name => {
  const [toggleButton, setToggleButton] = useState({ name, active: false });

  const handleToggleClick = () => {
    const prevButton = { ...toggleButton };
    const nextButton = { ...prevButton, active: !prevButton.active };
    setToggleButton(nextButton);
  };

  return [toggleButton, handleToggleClick, setToggleButton];
};
